(function () {
    'use strict';

    angular
        .module('externalPartyEditModule')
        .controller('ODDCampaignEditController', Controller);

    Controller.$inject = ['$scope', '$stateParams', '$state', 'modalService', 'businessUnit', 'externalParty', 'campaign'];

    function Controller($scope, $stateParams, $state, modalService, businessUnit, externalParty, campaign) {
        $scope.externalParty = externalParty;
        $scope.campaign = campaign;
        $scope.businessUnit = businessUnit;

        $scope.goToExternalParty = function () {
            $state.go('odd.externalPartyEdit', null, {reload: true});
        };

        $scope.goToQuestionnaire = function(questionnaire) {
            $state.go('odd.externalPartyEdit.campaign.questionnaire', {
                ODDCampaignQuestionnaireID: questionnaire.ODDCampaignQuestionnaireID
            });
        };

        $scope.goToQuestionnaireListEdit = function () {
            $state.go('odd.externalPartyEdit.campaign.editQuestionnaireList', { campaign: campaign });
        };

        $scope.goToInviteDetails = function () {
            $state.go('odd.externalPartyEdit.campaign.inviteDetails');
        };

        $scope.addQuestionnaire = function () {
            modalService.displayTemplateModal(
                'Choose a Questionnaire Template',
                require('./campaignQuestionnaireAddModal.tpl.html'),
                { campaign: campaign },
                false
            );
        };

        $scope.goToObservations = function () {
            $state.go('odd.externalPartyEdit.campaign.editObservationList', {
                ODDBusinessUnitCode: $stateParams.BusinessUnitCode,
                ODDCampaignID: $scope.campaign.ODDCampaignID
            })
        };
    }
})();
